export default __webpack_public_path__ + "static/media/martin_rafael.501e0aba.png";